import React from "react";
import Banner from "../assets/images/banner.jpg";

const About = () => {
  return (
    <>
      <section
        id="about"
        className="w-full pb-10 bg-black flex flex-col justify-center bg-opacity-[0.05]"
      >
        <div className="container mx-auto mt-10 flex flex-col items-center gap-10 lg:flex-row ">
          <div className="flex-col space-y-4 w-11/12 mx-auto lg:w-1/2">
            <p className="text-2xl font-semibold opacity-80 sm:text-3xl lg:text-4xl text-black mx-auto">
              About us
            </p>
            <p className="text-md lg:text-xl text-black opacity-80">
              At Revpoint Solutions, there's nothing we enjoy more than helping our clients solve business issues through effective use of technology. We provide a portfolio of IT Solutions and services that solves critical challenges for clients. Let us handle all of the complexities, so you can focus on the core business.
            </p>
          </div>
          <div className="w-11/12 mx-auto lg:w-1/2">
            <img
              src={Banner}
              alt=""
              className="w-full object-cover rounded-tl-3xl rounded-br-3xl "
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
